import { lazyLoadItemAttachment } from 'owa-itemattachment-store';
import { getUserMailboxInfo } from 'owa-client-ids';
import { setDeeplinkId } from 'owa-mail-reading-pane-store/lib/mutators/setDeeplinkId';
import { PopoutChildState, setPopoutChildState } from 'owa-popout-v2';

export interface ItemAttachmentRouteParamaters {
    attachmentId: string;
}

async function deepLinkItemAttachmentRouteHandler(parameters: ItemAttachmentRouteParamaters) {
    // Always set the deeplinkId if we are loading for deeplink
    const mailboxInfo = getUserMailboxInfo();
    setDeeplinkId(parameters.attachmentId, mailboxInfo);
    const loadItemAttachment = await lazyLoadItemAttachment.import();
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2345 (18,76): Argument of type 'null' is not assignable to parameter of type 'PerformanceDatapoint'.
    // @ts-expect-error
    await loadItemAttachment({ Id: parameters.attachmentId, mailboxInfo }, null);
    setPopoutChildState(PopoutChildState.Ready);
}

export default deepLinkItemAttachmentRouteHandler;
